import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { authGuard } from "./guards/auth.guard";
import { NotFoundComponent } from "./pages/no-url/not-found/not-found.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full"
  },
  {
    path: "",
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () => import('./pages/dashboards/dashboards.module').then(m => m.DashboardsModule)
      },
      {
        path: "audit-logs",
        loadChildren: () => import('./pages/audit-logs/audit-logs.module').then(m => m.AuditLogsModule)
      },
      {
        path: "components",
        loadChildren: () => import('./pages/components/components.module').then(m => m.ComponentsModule)
      },
      {
        path: "forms",
        loadChildren: () => import('./pages/forms/forms.module').then(m => m.FormsModules)
      },
      {
        path: "tables",
        loadChildren: () => import('./pages/tables/tables.module').then(m => m.TablesModule)
      },
      {
        path: "charts",
        loadChildren: () => import('./pages/charts/charts.module').then(m => m.ChartsModule)
      },
      {
        path: "calendar",
        loadChildren: () => import('./pages/calendar/calendar.module').then(m => m.CalendarModule)
      },
      {
        path: "features",
        loadChildren: () => import('./pages/examples/examples.module').then(m => m.ExamplesModule)
      },
      {
        path: "mid",
        loadChildren: () => import('./pages/mid/mid.module').then(m => m.MidModule)
      },
      {
        path: "accounts",
        loadChildren: () => import('./pages/accounts/accounts.module').then(m => m.AccountsModule)
      },
      {
        path: "create-account",
        loadChildren: () => import('./pages/create-account/create-account.module').then(m => m.CreateAccountModule)
      },
      {
        path: "transactions",
        loadChildren: () => import('./pages/transactions/transactions.module').then(m => m.TransactionsModule)
      },
      {
        path: "no-code",
        loadChildren: () => import('./pages/no-code/maya-payment.module').then(m => m.MayaPaymentModule)
      },
    ]
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "home",
        loadChildren: () => import('./pages/presentation/presentation.module').then(m => m.PresentationModule)
      },
      {
        path: "features",
        loadChildren: () => import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule)
      },
      { 
        path: "**", 
        component: NotFoundComponent 
      }
    ]
  },
  {
    path: "",
    loadChildren: () => import('./pages/no-url/no-url.module').then(m => m.NoUrlModule)
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      enableTracing: true // Debugging purposes only
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
